import './index.css';
import React from 'react';
import ReactDOM from 'react-dom/client';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <GlassPortfolio />
  </React.StrictMode>
);

const Button = ({ children, className, ...props }) => (
  <button className={`px-3 py-2 rounded ${className}`} {...props}>{children}</button>
);

const Card = ({ children, className, ...props }) => (
  <div className={`rounded-lg ${className}`} {...props}>{children}</div>
);

const CardContent = ({ children, className, ...props }) => (
  <div className={`p-4 ${className}`} {...props}>{children}</div>
);

export default function GlassPortfolio() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-pink-700 to-sky-600">
      <div className="container mx-auto px-4 py-8">
        <Card className="backdrop-blur-lg bg-white/10 shadow-xl rounded-xl overflow-hidden">
          <CardContent className="p-6">
            <header className="flex flex-col md:flex-row items-center justify-between mb-8">
              <div className="flex items-center mb-4 md:mb-0">
                <img
                  src="https://avatars.githubusercontent.com/u/86931568?v=4"
                  alt="Profile Picture"
                  className="w-24 h-24 rounded-full border-4 border-white shadow-lg"
                />
                <div className="ml-4">
                  <h1 className="text-2xl font-bold text-white">Alex Magee</h1>
                  <p className="text-xl text-white/80">Software Engineer</p>
                </div>
              </div>
              <div className="flex space-x-2">
                <a href='https://www.linkedin.com/in/xmagee/' target='_blank' rel="noreferrer">
                  <Button className="bg-white/20 hover:bg-white/30" alt="LinkedIn Profile">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="white" viewBox="0 0 16 16">
                      <title>LinkedIn</title>
                      <path d="M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854zm4.943 12.248V6.169H2.542v7.225zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248S2.4 3.226 2.4 3.934c0 .694.521 1.248 1.327 1.248zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016l.016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225z"/>
                    </svg>
                  </Button>
                </a>

                <a href='https://www.github.com/xmagee/' target='_blank' rel="noreferrer">
                  <Button className="bg-white/20 hover:bg-white/30" alt="Github Profile">
                    <svg width="16" height="16" fill="white" viewBox="0 0 26 26" xmlns="http://www.w3.org/2000/svg">
                      <title>GitHub</title>
                      <path d="M12 .297c-6.63 0-12 5.373-12 12 0 5.303 3.438 9.8 8.205 11.385.6.113.82-.258.82-.577 0-.285-.01-1.04-.015-2.04-3.338.724-4.042-1.61-4.042-1.61C4.422 18.07 3.633 17.7 3.633 17.7c-1.087-.744.084-.729.084-.729 1.205.084 1.838 1.236 1.838 1.236 1.07 1.835 2.809 1.305 3.495.998.108-.776.417-1.305.76-1.605-2.665-.3-5.466-1.332-5.466-5.93 0-1.31.465-2.38 1.235-3.22-.135-.303-.54-1.523.105-3.176 0 0 1.005-.322 3.3 1.23.96-.267 1.98-.399 3-.405 1.02.006 2.04.138 3 .405 2.28-1.552 3.285-1.23 3.285-1.23.645 1.653.24 2.873.12 3.176.765.84 1.23 1.91 1.23 3.22 0 4.61-2.805 5.625-5.475 5.92.42.36.81 1.096.81 2.22 0 1.606-.015 2.896-.015 3.286 0 .315.21.69.825.57C20.565 22.092 24 17.592 24 12.297c0-6.627-5.373-12-12-12"/>
                    </svg>
                  </Button>
                </a>

                <a href='https://www.goodreads.com/user/show/179757687-alexander' target='_blank' rel="noreferrer">
                  <Button className="bg-white/20 hover:bg-white/30" alt="Goodreads Profile">
                    <svg width="16" height="16" fill="white" viewBox="0 0 26 26" xmlns="http://www.w3.org/2000/svg">
                      <title>Goodreads</title>
                      <path d="M17.346.026c.422-.083.859.037 1.179.325.346.284.55.705.557 1.153-.023.457-.247.88-.612 1.156l-2.182 1.748a.601.601 0 0 0-.255.43.52.52 0 0 0 .11.424 5.886 5.886 0 0 1 .832 6.58c-1.394 2.79-4.503 3.99-7.501 2.927a.792.792 0 0 0-.499-.01c-.224.07-.303.18-.453.383l-.014.02-.941 1.254s-.792.985.457.935c3.027-.119 3.817-.119 5.439-.01 2.641.18 3.806 1.903 3.806 3.275 0 1.623-1.036 3.383-3.809 3.383a117.46 117.46 0 0 0-5.517-.03c-.31.005-.597.013-.835.02-.228.006-.41.011-.52.011-.712 0-1.648-.186-1.66-1.068-.008-.729.624-1.12 1.11-1.172.43-.045.815.007 1.24.064.252.034.518.07.815.088.185.011.366.025.552.038.53.038 1.102.08 1.926.087.427.005.759.01 1.025.015.695.012.941.016 1.28-.015 1.248-.112 1.832-.61 1.832-1.376 0-.805-.584-1.264-1.698-1.414-1.564-.213-2.33-.163-3.72-.074a87.66 87.66 0 0 1-1.669.095c-.608.029-2.449.026-2.682-1.492-.053-.416-.073-1.116.807-2.325l.75-1.003c.36-.49.582-.898.053-1.559 0 0-.39-.468-.52-.638-1.215-1.587-1.512-4.08-.448-6.114 1.577-3.011 5.4-4.26 8.37-2.581.253.143.438.203.655.163.201-.032.27-.167.363-.344.02-.04.042-.082.067-.126.004-.01.241-.465.535-1.028l.734-1.41a1.493 1.493 0 0 1 1.041-.785ZM9.193 13.243c1.854.903 3.912.208 5.254-2.47 1.352-2.699.827-5.11-1.041-6.023C10.918 3.537 8.81 5.831 8.017 7.41c-1.355 2.698-.717 4.886 1.147 5.818Z"/>
                    </svg>
                  </Button>
                </a>

                <a href='https://www.strava.com/athletes/125127298' target='_blank' rel="noreferrer">
                  <Button className="bg-white/20 hover:bg-white/30" alt="Strava Profile">
                    <svg width="16" height="16" fill="white" viewBox="0 0 26 26" xmlns="http://www.w3.org/2000/svg">
                      <title>Strava</title>
                      <path d="M15.387 17.944l-2.089-4.116h-3.065L15.387 24l5.15-10.172h-3.066m-7.008-5.599l2.836 5.598h4.172L10.463 0l-7 13.828h4.169"/>
                    </svg>
                  </Button>
                </a>

                <a href='mailto:alex@magee.us'>
                  <Button className="bg-white/20 hover:bg-white/30" alt="Email Link">
                    <svg width="16" height="16" fill="white" viewBox="0 0 26 26" xmlns="http://www.w3.org/2000/svg">
                      <title>Gmail</title>
                      <path d="M24 5.457v13.909c0 .904-.732 1.636-1.636 1.636h-3.819V11.73L12 16.64l-6.545-4.91v9.273H1.636A1.636 1.636 0 0 1 0 19.366V5.457c0-2.023 2.309-3.178 3.927-1.964L5.455 4.64 12 9.548l6.545-4.91 1.528-1.145C21.69 2.28 24 3.434 24 5.457z"/>
                    </svg>
                  </Button>
                </a>
              </div>
            </header>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-white mb-2">About Me</h2>
              <p className="text-white/80">
               The #1 shareholder value generator. 9 out of 10 doctors agree on this.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-white mb-2">Experience</h2>
              <div className="space-y-4">
                {[
                  {
                    title: "Software Engineer",
                    company: "NeuroFlow",
                    companyUrl: "https://www.linkedin.com/company/neuroflow/",
                    period: "2024 - Present",
                    description: "Engineering and maintaining large-scale projects used to deliver behavioral health questionnaires to tens of thousands of users across the country.",
                  },
                  {
                    title: "Software Engineer",
                    company: "Seneca Resources",
                    companyUrl: "http://linkedin.com/company/seneca-resources-inc-/",
                    period: "2022 - 2024",
                    description: "Full stack engineer focused on creating and maintaining web and mobile projects assisting in the process of responsible fracking/extraction of natural gas.",
                  },
                  {
                    title: "Software Engineer",
                    company: "American Refining Group",
                    companyUrl: "https://www.linkedin.com/company/american-refining-group-inc./",
                    period: "2019 - 2022",
                    description: "Individual contributor; lead design and development for an app that automates the generation and renewal of oil well lease agreement documents.",
                  },
                  {
                    title: "Volunteer Web Dev",
                    company: "CASA of Mckean County",
                    companyUrl: "https://www.linkedin.com/company/casa-of-mckean-county/",
                    period: "2019 - 2024",
                    description: "Assisted with content management and website design for a non-profit focused on helping the local community.",
                  },
                ].map((job, index) => (
                  <Card key={index} className="bg-white/10 backdrop-blur-sm">
                    <CardContent>
                      <h3 className="font-semibold text-white">{job.title}</h3>
                      <p className="text-sm text-white/70"><a href={job.companyUrl} target="_blank">{job.company}</a> | {job.period}</p>
                      <p className="mt-2 text-white/80">{job.description}</p>
                    </CardContent>
                  </Card>
                ))}
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-white mb-2">Education</h2>
              <div className="space-y-4">
                {[
                  {
                    title: "Bachelors of Science",
                    company: "University of Pittsburgh",
                    period: "2016 - 2020",
                    description: "Web dev, Esports club; President, IT Club.",
                  },
                ].map((job, index) => (
                  <Card key={index} className="bg-white/10 backdrop-blur-sm">
                    <CardContent>
                      <h3 className="font-semibold text-white">{job.title}</h3>
                      <p className="text-sm text-white/70">{job.company} | {job.period}</p>
                      <p className="mt-2 text-white/80">{job.description}</p>
                    </CardContent>
                  </Card>
                ))}
              </div>
            </section>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
